import { render, staticRenderFns } from "./return.vue?vue&type=template&id=b32f7a42&scoped=true"
import script from "./return.vue?vue&type=script&lang=js"
export * from "./return.vue?vue&type=script&lang=js"
import style0 from "./return.vue?vue&type=style&index=0&id=b32f7a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32f7a42",
  null
  
)

export default component.exports